import { render, staticRenderFns } from "./ForgotPassword.vue?vue&type=template&id=771f5339"
import script from "./ForgotPassword.vue?vue&type=script&lang=js"
export * from "./ForgotPassword.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/authen.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "@/assets/css/newLogin.css?vue&type=style&index=1&prod&lang=css&external"
import style2 from "./ForgotPassword.vue?vue&type=style&index=2&id=771f5339&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports